import { brand } from "./brands";

const hexToRgbChannels = (hex: string): string => {
  const value = hex.replace("#", "");
  const r = parseInt(value.slice(0, 2), 16);
  const g = parseInt(value.slice(2, 4), 16);
  const b = parseInt(value.slice(4, 6), 16);
  return `${r} ${g} ${b}`;
};

/**
 * Applies the build-time brand to the document: CSS variables (consumed by
 * Tailwind's color tokens), title, favicon and theme-color. Called once before render.
 */
export const applyBrand = () => {
  const root = document.documentElement;
  // Raw RGB channels so Tailwind opacity modifiers (bg-primary/10) keep working.
  root.style.setProperty("--brand-primary", hexToRgbChannels(brand.colors.primary));
  root.style.setProperty("--brand-primary-strong", hexToRgbChannels(brand.colors.primaryStrong));
  root.style.setProperty("--brand-ink", hexToRgbChannels(brand.colors.ink));
  root.style.setProperty("--brand-header-bg", hexToRgbChannels(brand.colors.headerBg));

  document.title = brand.name;

  let favicon = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
  if (!favicon) {
    favicon = document.createElement("link");
    favicon.rel = "icon";
    document.head.appendChild(favicon);
  }
  favicon.href = brand.favicon;

  let themeColor = document.querySelector<HTMLMetaElement>("meta[name='theme-color']");
  if (!themeColor) {
    themeColor = document.createElement("meta");
    themeColor.name = "theme-color";
    document.head.appendChild(themeColor);
  }
  themeColor.content = brand.colors.headerBg;
};
